import React from 'react';
import {connect} from 'react-redux';
import {Tabs, Tab} from 'material-ui/Tabs';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

import * as commonApi from '../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import moment from 'moment';
import {IndexLink, Link} from 'react-router';
import Waypoint from 'react-waypoint';

import Splash_Signin from '../commons/splash_signin';
import Footer2Component from '../commons/footer2';
import CoursePostsFeeds from '../../appcomponents/commons/course/course_posts_feeds';
import POPUP from '../../appcomponents/commons/popup';
import LoginPopup from "../../appcomponents/commons/LoginPopup";

const customStyles2 = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        margin: '0',
        padding: '80px 0px',
        width: '600px',
        height: '380px',
        minHeight: '300px',
        zIndex: '999',
        textAlign: 'center'
    }
};

export default class CompanyPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        var slideIndex = 0;

        var compId = this.props.params.compId;

        if (this.props.params.ptab == "jobs") {
            slideIndex = 1;
        }
        if (this.props.params.ptab == "events") {
            slideIndex = 2;
        }

        this.state = {seeMore: false, compId: compId, slideIndex: slideIndex, itemArr2: [], items2: [], start2: 0, feeds: [], showLoginPopover: false, start: 0, total: 0, load_done: false};
    }

    handleChange(value) {
        if (typeof value != "number") {
            return;
        }
        this.setState({
            slideIndex: value,
        });
        if (value == 0) {
            this.props.router.replace('/company/' + this.state.compId + '/about');
        }

        if (value == 1) {
            this.props.router.replace('/company/' + this.state.compId + '/jobs');
        }
        if (value == 2) {
            this.props.router.replace('/company/' + this.state.compId + '/events');
        }
    };

    componentDidMount() {
        this.getCompany();
        this.getSiteJobs();
        // this.getFeed2();
    }

    _parseDate(date) {
        return date && moment(date).isValid() ? moment(date).format('MMMM DD YYYY') : 'Open Until Filled';
    }

    getSiteJobs() {
        this.setState({loading: true});
        var location = "";
        var search = "";
        var url = "/code/apis.php?api=getSiteJobs";
        var data = new FormData();

        data.append("company", this.state.compId);
        data.append("start", this.state.start2);
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    var start2 = this.state.start2;
                    start2 += response.data.data.length;
                    var itemArr2 = this.state.itemArr2;
                    //var end = response.data.end;

                    var city = "";
                    for (var item of response.data.data) {
                        if (city == "") {
                            city = item.location_job;
                        }
                        var name = item.name_company.substring(0, 1);

                        if (item.file != undefined) {
                            name = (<img src={item.file.link_file}/>);
                        }
                        else {
                            name = (<div className="c_logo">{name}</div>);
                        }
                        itemArr2.push(<div className="job_item" key={"jobsite-item-" + item.id_job}>
                            <a href={"/jobsitedetail/" + item.id_job} target="_blank">
                                <div className="clickable">
                                    <div className="job_item_left">
                                        <div className="item_logo_w">
                                            <div className="item_logo">
                                                {name}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="job_item_right">
                                        <div className="item_title">
                                            {item.title_job}
                                        </div>
                                        <div className="item_com">
                                            {item.name_company}
                                        </div>
                                        <div className="item_detail_container">
                                            <b>{item.type_job} {item.industry_job}</b> opportunity in
                                            the <b>{item.func_job}</b> industry
                                            <div className="item_detail"
                                                 dangerouslySetInnerHTML={{__html: item.des_job}}/>
                                        </div>
                                        {
                                            item.location_job
                                            && <div className="item_location">
                                                {item.location_job}&nbsp;&minus;&nbsp;
                                            </div>
                                        }
                                        {
                                            item.time_job
                                            && <div className="item_time">
                                                Application Deadline: {this._parseDate(item.exp_job)}
                                            </div>
                                        }
                                    </div>

                                </div>
                            </a>

                            <a className="btn_v btn_cancel apply2" href={item.url_job} target="_blank">APPLY ON SITE</a>

                        </div>);
                    }
                }

                this.setState({loading: false});
                return response;
            }).catch(error => {
            this.setState({loading: false});
        });
    }

    getCompany() {
        axios.get(commonApi.getAPIURL() + '?api=getCompanyView&comp_id=' + this.state.compId)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({company: response.data.data});
                }
                else {
                    //window.location = "/";
                }
                return response;
            });
    }

    componentWillReceiveProps(nextProps) {
        var load = false;
        if (this.state.compId != nextProps.params.compId) {
            load = true;
        }

        if (load) {
            this.setState({compId: nextProps.params.compId}, () => {
                this.getCompany();
            });
        }

        else {
            this.setState({compId: nextProps.params.compId});
        }
    }

    follow() {
        this.viewLoginPopover();
    }

    unfollow() {
        this.viewLoginPopover();
    }

    // getFeed2() {
    //     axios.get(commonApi.getAPIURL() + '?api=getHomeFeed&id_company=' + this.state.compId + '&is_public=1')
    //         .then(response => {
    //             if (response.data.status == 1) {
    //                 this.setState(Object.assign(this.state, {feeds: response.data.data}));
    //             }
    //             return response;
    //         });
    // }

    onCloseLoginPopover() {
        this.setState({showLoginPopover: false});
    }

    viewLoginPopover(e) {
        this.setState({showLoginPopover: true});
    }

    getHomeFeed() {
        this.setState({loading: true});
        var data = new FormData();
        data.append("start", this.state.start);
        data.append("id_company", this.state.compId);
        axios.post('/code/api_feeds.php?api=getFeedsHome', data)
            .then(response => {
                var feeds = this.state.feeds;
                if (response.data.status == 1) {

                    this.setState(Object.assign(this.state, {feeds: feeds.concat(response.data.data), loading: false, load_done: true, total: response.data.total}));
                }
                else {
                    this.setState({loading: false});
                }
                return response;
            });
    }

    _handleWaypointEnter() {
        this.setState({start: this.state.feeds.length}, () => {
            this.getHomeFeed();
        });
    }

    handleClickSee = (event) => {
        const seeMore = this.state.seeMore?false:true;
        this.setState({seeMore: seeMore});
    }

    render() {
        if (this.state.company == undefined) {
            return (
                <div className="app_page_wrapper">
                    <div style={{color: "#545454"}}>
                        <div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>
                    </div>
                </div>
            );
        }
        var avatar = this.state.company.name_company.substring(0, 1).toUpperCase();
        var avatar_circle = this.state.company.name_company.substring(0, 1).toUpperCase();
        if (this.state.company.id_file_company != 0) {
            avatar = (<img className="img_nocircle_p" src={this.state.company.file.link_file} alt=""/>);
            avatar_circle = (<img className="img_circle" src={this.state.company.file.link_file} alt=""/>);
        }
        var social = [];
        if (this.state.company.fb_company != "") {
            social.push(<a key="comp-fb" href={this.state.company.fb_company} target="_blank"><img alt="" src="/static/img/homeimg/splash-social-fb.png" style={{height: "21px", width: "auto", marginRight: "5px"}}/></a>)
        }
        if (this.state.company.tw_company != "") {
            social.push(<a key="comp-tw" href={this.state.company.tw_company} target="_blank"><img alt="" src="/static/img/homeimg/splash-social-tt.png" style={{height: "21px", width: "auto", marginRight: "5px"}}/></a>)
        }
        if (this.state.company.in_company != "") {
            social.push(<a key="comp-in" href={this.state.company.in_company} target="_blank"><img alt="" src="/static/img/appimg/Linkedin_logo.png" style={{height: "21px", width: "auto", marginRight: "5px"}}/></a>)
        }
        var slist = [];
        if (this.state.company.slist != undefined && Object.keys(this.state.company.slist).length > 0) {
            for (var user of this.state.company.slist) {
                slist.push(<img key={"slist-" + user.id_account} className="img_circle_s slist_item" src={user.link_thumb_file} alt=""/>);
            }
            if (this.state.company.count - this.state.company.slist.length > 0) {
                slist.push(<span key="slist-more" className="slist_item slist_more" alt="">+{this.state.company.count - this.state.company.slist.length}</span>);
            }
        }
        var follow_div = "";
        var follow_btn = "";
        var follow = "0 follower";
        if (this.state.company.follow == 1) {
            follow = "1 follower";
        }
        if (this.state.company.follow > 1) {
            follow = this.state.company.follow + " followers";
        }
        if (this.state.company.is_follow == 0) {
            follow_div = (<div className="follow t-14"><a className="btn_v btn_confirm button-primary-medium" onClick={this.follow.bind(this)}>Follow</a> {follow}</div>);
            follow_btn = (<a className="btn_v btn_confirm t-14 button-primary-medium" onClick={this.follow.bind(this)}>Follow</a>);
        }
        else {
            follow_div = (<div className="follow t-14"><a className="btn_v btn_confirm button-primary-medium" onClick={this.unfollow.bind(this)}>Unfollow</a> {follow}</div>);
            follow_btn = (<a className="btn_v btn_confirm t-14 button-primary-medium" onClick={this.unfollow.bind(this)}>Unfollow</a>);
        }
        let bg_outside_url = (this.state.company.id_banner_file_company == 0 || this.state.company.id_banner_file_company == "0")
            ? 'https://i.imgur.com/Ek7Ee3wr.jpg'
            : this.state.company.bfile.link_file;
            bg_outside_url = 'url(' + bg_outside_url + ')';
        if (isMobile) {
            return (
                <div id={"response-profile-mobile"}>
                    <header>
                        <div className="header">
                            <div className="splash_logo">
                                <Link to="/"><img alt="VERSITY" src="/static/img/appimg/login_h_logo.png"/></Link>
                            </div>
                            <div className={"sign-in"}>
                                <span><Link to="/signin" className={"btn-white"}>Sign in</Link></span>
                                <Link to="/signup" className={"btn"}>Join now</Link>
                            </div>
                        </div>
                    </header>
                    <div className={"pf_outside_wrapper"}>
                        <div id={"pf_company"} className="bg_outside public_company" style={{backgroundImage: bg_outside_url}}>
                            <div className="pf_header">
                                <div className="pf_logo">
                                    {avatar.length == 1 ? (<a className="img_nocircle_wrapper" style={{
                                        backgroundColor: "#8c8c8c",
                                        color: "white",
                                        textAlign: "center",
                                        lineHeight: "140px",
                                        fontSize: "60pt"
                                    }}>{avatar}</a>) : (<a className="img_nocircle_wrapper" style={{color: "white"}}>{avatar}</a>)}
                                </div>
                                <div className="pf_title">
                                    <div>
                                        <h2><p className={'t-24'}>{this.state.company.name_company}</p></h2>
                                        <p className={'t-14'}>{this.state.company.cat_company}</p>
                                        <p className={"t-14"}> {this.state.company.city_company}</p>
                                        {follow_div}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"pf-feeds"}>
                            <div className={"about-us-wrap"}>
                                <div className={"about-us"}>
                                    <span className={'t-18'}>About Us</span>
                                    <div className="row_box_right t-14 w-auto org-page-details__definition-text" dangerouslySetInnerHTML={{__html: this.state.company.des_company}}></div>

                                    <div className={this.state.seeMore?'':'hide-el'}>
                                        <span className={"pf_ab_tiltle"}>Website</span>
                                        <p>{this.state.company.web_company}</p>

                                        <span className={"pf_ab_tiltle"}>Headquarters</span>
                                        <p>{this.state.company.city_company}</p>

                                        <span className={"pf_ab_tiltle"}>Founded</span>
                                        <p>{this.state.company.founded_company}</p>

                                        <span className={"pf_ab_tiltle"}>Employees</span>
                                        <p>{this.state.company.emp_company}</p>

                                        <span className={"pf_ab_tiltle"}>Categories</span>
                                        <p>{this.state.company.cat_company}</p>
                                    </div>
                                </div>
                                <div className={"btn_see"} onClick={this.handleClickSee.bind(this)}>
                                    {this.state.seeMore?
                                        <span>See less <p className="glyphicon glyphicon-menu-up" aria-hidden="true"></p></span>
                                        :<span>See more <p className="glyphicon glyphicon-menu-down" aria-hidden="true"></p></span>
                                    }
                                </div>
                            </div>
                            <div className={"recent-update"}>Recent Updates:</div>
                            {this.state.feeds.length > 0 ?
                                <div className={"col-md-8"}>
                                    <CoursePostsFeeds key="normal_feed" detail={1} user={0} courseId={0}
                                                      feeds={this.state.feeds}
                                                      isMobile={1}
                                                      handleFeedCallback={this.handleFeedCallback}/>
                                    {this.state.loading?(<div className="center_div"><Loading type='bubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>):""}
                                </div>:""
                            }
                        </div>
                    </div>
                    <Waypoint
                        bottomOffset={-20}
                        onEnter={this._handleWaypointEnter.bind(this)}
                    />
                    <div className={"footerClear"}>&nbsp;</div>
                    <Footer2Component/>
                    <POPUP style={customStyles2} show={this.state.showLoginPopover} onClose={this.onCloseLoginPopover.bind(this)} content={( <LoginPopup msg={"follow this company"} onClose={this.onCloseLoginPopover.bind(this)} />)} />
                </div>
            )
        }
        return (
            <div>
                <div id="company">
                    <header>
                        <div className="header">
                            <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                            <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                        </div>
                    </header>
                    <div className="splash_wrapper"></div>
                </div>
                <div className={"outside_wrapper"}>
                    <div id={"e_company"} className="bg_outside public_company" style={{backgroundImage: bg_outside_url}}>
                    <div className="app_page_wrapper" style={{margin: '0px auto'}}>
                        <div className="common_header01 common_header02">
                            <div className="common_headlogo02">
                                {avatar.length == 1 ? (<a className="img_nocircle_wrapper" style={{
                                    backgroundColor: "#8c8c8c",
                                    color: "white",
                                    textAlign: "center",
                                    lineHeight: "140px",
                                    fontSize: "60pt"
                                }}>{avatar}</a>) : (<a className="img_nocircle_wrapper" style={{backgroundColor: "#8c8c8c", color: "white"}}>{avatar}</a>)}
                            </div>
                            <div className="common_title02">
                                <div>
                                    <h2><b className={'t-24'}>{this.state.company.name_company}</b></h2>
                                    <p className={"t-14"}>{this.state.company.cat_company} · {this.state.company.city_company}</p>
                                    {follow_div}
                                </div>
                            </div>
                        </div>
                        <div className={"common_tab"}>
                            <div onClick={this.handleChange.bind(this, 0)}
                                 className={this.state.slideIndex == 0 ? "tab_each active" : "tab_each"}>Overview
                            </div>
                            <div onClick={this.handleChange.bind(this, 1)}
                                 className={this.state.slideIndex == 1 ? "tab_each1 active" : "tab_each1"}>Jobs & Internships
                            </div>
                            <div onClick={this.handleChange.bind(this, 2)}
                                 className={this.state.slideIndex == 2 ? "tab_each active" : "tab_each"}>Events
                            </div>
                        </div>

                        <div id="profile-page" className="md-page" style={{width: "920px"}}>
                            <div className="page_n_main_wrapper">
                                <div className="content" style={{marginTop: 0, paddingBottom: 0}}>
                                    <div label="About" value={0}
                                         className={this.state.slideIndex == 0 ? "tab_item" : "hide-el tab_item"}>
                                        <div className="page_course_box company_content_wrapper">
                                            <div className="title_box t-18  org-page-details__definition-text"><b>Overview</b></div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    Headquarters
                                                </div>
                                                <div className="row_box_right t-14 org-page-details__definition-text">
                                                    {this.state.company.city_company}
                                                </div>
                                            </div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    About Us
                                                </div>
                                                <div className="row_box_right t-14 w-auto org-page-details__definition-text" dangerouslySetInnerHTML={{__html: this.state.company.des_company}}></div>
                                            </div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    Founded
                                                </div>
                                                <div className="row_box_right t-14 org-page-details__definition-text">
                                                    {this.state.company.founded_company}
                                                </div>
                                            </div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    Employees
                                                </div>
                                                <div className="row_box_right t-14 org-page-details__definition-text">
                                                    {this.state.company.emp_company}
                                                </div>
                                            </div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    Categories
                                                </div>
                                                <div className="row_box_right t-14 org-page-details__definition-text">
                                                    {this.state.company.cat_company}
                                                </div>
                                            </div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    Website
                                                </div>
                                                <div className="row_box_right t-14 org-page-details__definition-text">
                                                    {this.state.company.web_company}
                                                </div>
                                            </div>
                                            <div className="row_box">
                                                <div className="row_box_left t-14 t-bold">
                                                    Social
                                                </div>
                                                <div className="row_box_right t-14">
                                                    {social}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div label="Jobs & Internships" value={1}
                                         className={this.state.slideIndex == 1 ? "tab_item" : "hide-el tab_item"}>
                                        {this.state.itemArr2.length == 0 ? (
                                            <div className="page_course_box company_content_wrapper d-table">
                                                <p className="tcenter t-18 d-midle">We currently have no open positions. However you
                                                    can follow us by clicking
                                                    follow at the top, and be notified when we post a position that
                                                    matches your qualifications.</p>
                                            </div>) : (<div className="page_course_box job_section">
                                            <div className="job_list">
                                                {this.state.itemArr2}
                                            </div>
                                        </div>)}
                                    </div>
                                    <div label="Events" value={2}
                                         className={this.state.slideIndex == 2 ? "tab_item" : "hide-el tab_item"}>
                                        <div className="page_course_box company_content_wrapper d-table">
                                            <p className="tcenter t-18 d-midle">We currently have no scheduled events.</p>
                                        </div>
                                    </div>
                                    <div className={"recent-update"}>Recent Updates:</div>
                                    <div className="row recent-content">
                                        <div className={"col-md-4"}>
                                            <div className="page_course_box feed_section">
                                                <div className="feed_top_box" style={{display: "block"}}>
                                                    <div className="feed_top_left">
                                                        {avatar_circle}
                                                    </div>
                                                    <div className="feed_top_right">
                                                        <div className="feed_name user_name t-14 t-bold">
                                                            {this.state.company.name_company}
                                                            {follow_btn}
                                                        </div>
                                                        <div className="feed_user_major t-14">
                                                            {follow}<br/>
                                                            {this.state.total} updates
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="feed_mid_box">
                                                    <div className="feed_content feed_company t-14 mrb-10">
                                                        Follow us to stay up to date with {this.state.company.name_company}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.feeds.length > 0 ?
                                            <div className={"col-md-8 div-right"}>
                                                <CoursePostsFeeds key="normal_feed" detail={1} user={0} courseId={0}
                                                                  feeds={this.state.feeds}
                                                                  handleFeedCallback={this.handleFeedCallback}/>
                                                {this.state.loading?(<div className="center_div"><Loading type='bubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>):""}
                                            </div>:""
                                        }
                                        {this.state.load_done && this.state.total <= 0 ?
                                            <div className={"col-md-8 div-right d-table"}>
                                                <div className="page_course_box_empty t-18 d-midle">
                                                    We currently have no status updates.
                                                </div>
                                            </div>:""
                                        }
                                    </div>
                                </div>
                                <Waypoint
                                    bottomOffset={-20}
                                    onEnter={this._handleWaypointEnter.bind(this)}
                                />
                            </div>
                        </div>
                        <div className="md-page-side page_list">
                            <ul>
                                <li className={"light"}>
                                    <p className={'t-18 t-normal'}>Contact Information</p>
                                    <p className={"t-14 t-bold"}>Website</p>
                                    <div className={"txt t-14"}>{this.state.company.web_company}&nbsp;</div>
                                    {/*<p className={"title"}>Email</p>*/}
                                    {/*<div className={"txt"}>{this.state.company.email_company}&nbsp;</div>*/}
                                    <div className={"social"}>{social}</div>
                                </li>
                                <li className={"circle"}>
                                    <p className={'t-14 t-bold'}>Jobs at {this.state.company.name_company}</p>
                                    {/*
                                    <p className={"title"}>Management Trainee Resort Opera...</p>
                                    <div className={"txt"}>Mirriott Vacations Worldwide</div>
                                    */}
                                    <div className={"view t-14"}>View All Jobs</div>
                                </li>
                                <li className={"circle"}>
                                    <div className={"txt flag"}>
                                        <img src="/static/img/appimg/icon_feed_flag.png"/>
                                        <p className={"flag"}>Flag this page for abuse</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                </div>

                <POPUP style={customStyles2} show={this.state.showLoginPopover} onClose={this.onCloseLoginPopover.bind(this)} content={( <LoginPopup msg={"follow this company"} onClose={this.onCloseLoginPopover.bind(this)} />)} />
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/company.js
 **/